import { z } from 'zod';
// Direct module import, NOT the vehiclesearch barrel: the barrel re-exports components that
// reach hooks and services, and this schema needs one constant.
import { VRM_LENGTH_MESSAGE } from '@features/vehiclesearch/schemas/additionalvehicledetails.schema';

export const VEHICLE_IDENTITY_REQUIRED =
    'Enter the vehicle registration number or the VIN to continue. Either one is enough.';

// Mirrors StoreQuoteRequest's vehicle.vin rule; must not be loosened, because this
// form saves immediately.
export const MOPUP_VIN_MESSAGE = 'VIN must be 17 characters, using A-Z and 0-9 but not I, O or Q.';

export const vehicleIdentitySchema = z
    .object({
        vrm: z.string().min(2, VRM_LENGTH_MESSAGE).max(7, VRM_LENGTH_MESSAGE).optional(),
        vin: z.string().regex(/^[A-HJ-NPR-Z0-9]{17}$/, MOPUP_VIN_MESSAGE).optional(),
    })
    .superRefine((values, ctx) => {
        if (values.vrm === undefined && values.vin === undefined) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                // One message, hung off the registration field. Both inputs point at it via
                // aria-describedby; duplicating it under both would be noise.
                path: ['vrm'],
                message: VEHICLE_IDENTITY_REQUIRED,
            });
        }
    });

export type VehicleIdentityFormInputs = z.infer<typeof vehicleIdentitySchema>;
